// Verify auth token and redirect to dashboard

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Layout } from '../components/Layout';
import { api } from '../services/api';
import { useAuth } from '../hooks/useAuth';

export function VerifyAuth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('No token provided');
      return;
    }

    const verifyToken = async () => {
      try {
        const result = await api.verifyToken(token);

        login(result.sessionToken, result.email);
        localStorage.setItem('sessionStart', Date.now().toString());

        navigate('/dashboard');
      } catch (err) {
        setError('Invalid or expired login link. Please request a new one.');
      }
    };

    verifyToken();
  }, [searchParams, login, navigate]);

  return (
    <Layout>
      <div className="max-w-md mx-auto mt-8">
        <div className="bg-card border border-border rounded-xl p-8 text-center">
          {error ? (
            <>
              <div className="text-destructive mb-4">
                <AlertTriangle className="w-12 h-12 mx-auto" />
              </div>
              <h2 className="text-xl font-semibold mb-2 text-foreground">Verification Failed</h2>
              <p className="text-muted-foreground mb-4">{error}</p>
              <a
                href="/"
                className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium px-6 py-2.5 rounded-md hover:bg-primary/90 transition-all text-sm"
              >
                Back to Login
                <ArrowRight className="w-4 h-4" />
              </a>
            </>
          ) : (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
              <h2 className="text-xl font-semibold mb-2 text-foreground">Verifying...</h2>
              <p className="text-muted-foreground">Please wait while we verify your login link.</p>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
